import React, { useContext } from 'react'
import { DropdownDiscriminatedProps } from '@App/forms/common/dropdown-form-field'
import DropdownForm from '@Fields/DropdownForm'
import { RightsholderContactTypes } from '@App/enum/rightsholder-contact-types'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'

interface ContactTypeProps {
    rightsholderContactTypeId: DropdownDiscriminatedProps
}

const ContactType = (props: ContactTypeProps) => {
    const { contactStore } = useContext(StoresContext)

    const { rightsholderContactTypeId } = props

    const checkCanSubmitNewPublicContact = (currentContactType: RightsholderContactTypes) =>
        RightsholderContactTypes.PUBLIC === currentContactType && contactStore.rightsholderHasPublicContact
            ? 'A public contact already exists for this member'
            : true

    if (rightsholderContactTypeId.registerOptions) {
        rightsholderContactTypeId.registerOptions.validate = checkCanSubmitNewPublicContact
    }

    return (
        <>
            <h5>Contact Type</h5>
            <div className="contact-sub-section">
                <DropdownForm {...rightsholderContactTypeId} />
            </div>
        </>
    )
}

export default observer(ContactType)
